module.exports = __webpack_public_path__ + "img/UserProfile.4b2b8914.svg";